import React from 'react';
import styled from 'styled-components';
import { FiSearch, FiFilter } from 'react-icons/fi';
import theme from '../../styles/theme';

const FiltrosContainer = styled.div`
  background: ${theme.colors.background.secondary};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.xl};
  padding: ${theme.spacing[4]};
`;

const FiltrosHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  margin-bottom: ${theme.spacing[4]};
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  font-weight: 600;
`;

const FiltrosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${theme.spacing[4]};
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

const Label = styled.label`
  color: ${theme.colors.text.muted};
  font-size: ${theme.fontSizes.sm};
  font-weight: 500;
`;

const Input = styled.input`
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.base};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }

  &::placeholder {
    color: ${theme.colors.text.muted};
  }
`;

const Select = styled.select`
  padding: ${theme.spacing[3]} ${theme.spacing[4]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.base};
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }

  option {
    background: ${theme.colors.background.primary};
    color: ${theme.colors.text.primary};
  }
`;

const BuscarButton = styled.button`
  padding: ${theme.spacing[3]} ${theme.spacing[6]};
  background: ${theme.colors.primary[500]};
  color: ${theme.colors.text.primary};
  border: none;
  border-radius: ${theme.borderRadius.lg};
  font-size: ${theme.fontSizes.base};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  align-self: flex-end;

  &:hover {
    background: ${theme.colors.primary[600]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ParametrosIAFiltros = ({
  filtros,
  clientes = [],
  onFiltrosChange,
  onBuscar,
  loading
}) => {
  const handleChange = (campo, valor) => {
    onFiltrosChange({
      ...filtros,
      [campo]: valor
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onBuscar();
  };

  return (
    <FiltrosContainer>
      <FiltrosHeader>
        <FiFilter />
        Filtros
      </FiltrosHeader>

      <form onSubmit={handleSubmit}>
        <FiltrosGrid>
          <FormGroup>
            <Label htmlFor="search">Buscar por cliente</Label>
            <Input
              id="search"
              type="text"
              placeholder="Nome do cliente..."
              value={filtros.search || ''}
              onChange={(e) => handleChange('search', e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="cliente">Cliente</Label>
            <Select
              id="cliente"
              value={filtros.id_cliente || ''}
              onChange={(e) => handleChange('id_cliente', e.target.value)}
            >
              <option value="">Todos os clientes</option>
              {clientes.map((cliente) => (
                <option key={cliente.id} value={cliente.id}>
                  {cliente.nome || cliente.nome_fantasia}
                </option>
              ))}
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="ambiente">Ambiente</Label>
            <Select
              id="ambiente"
              value={filtros.ambiente || ''}
              onChange={(e) => handleChange('ambiente', e.target.value)}
            >
              <option value="">Todos</option>
              <option value="HML">Homologação</option>
              <option value="PRD">Produção</option>
            </Select>
          </FormGroup>

          <FormGroup>
            <Label htmlFor="ativo">Status</Label>
            <Select
              id="ativo"
              value={filtros.ativo || ''}
              onChange={(e) => handleChange('ativo', e.target.value)}
            >
              <option value="">Todos</option>
              <option value="true">Ativo</option>
              <option value="false">Inativo</option>
            </Select>
          </FormGroup>

          <FormGroup>
            <Label>&nbsp;</Label>
            <BuscarButton type="submit" disabled={loading}>
              <FiSearch />
              {loading ? 'Buscando...' : 'Buscar'}
            </BuscarButton>
          </FormGroup>
        </FiltrosGrid>
      </form>
    </FiltrosContainer>
  );
};

export default ParametrosIAFiltros;
